import { cva } from "../../styled-system/css";

export const CheckboxStyle = cva({
  base: {
    accentColor: "#18181B",
    aspectRatio: "1 / 1",
    cursor: "pointer",
    "&:disabled": { cursor: "not-allowed" },
  },

  variants: {
    height: {
      "16px": { height: "16px" },
    },
  },
});

export const SwitchStyle = cva({
  base: {
    appearance: "none",
    cursor: "pointer",
    outline: "none",
    display: "inline-block",
    width: "40px",
    height: "24px",
    borderRadius: "12px",
    verticalAlign: "middle",
    backgroundColor: "#666666",
    transition: "0.1s",

    _before: {
      content: '""',
      display: "block",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      transform: "scale(0.825)",
      backgroundColor: "#FFFFFF",
      transition: "inherit",
    },

    _disabled: { opacity: 0.4 },

    "&:checked,&[data-state=checked]": {
      backgroundColor: "#0D9488",
    },

    "&:checked::before,&[data-state=checked]::before": {
      transform: "scale(0.825) translateX(19.5px)",
    },
  },

  variants: {
    display: {
      block: { display: "block" },
    },
  },
});
